
// Base URLs
export const BASE_URL = process.env.REACT_APP_CALL_API_URL;

// API Endpoints
export const API_ENDPOINTS = {
  LOGIN: '/v3/dang-nhap',
  LOGOUT: '/v3/dang-xuat',
  AIRLINE_LIST: '/v3/hang-bay/danh-sach',
  PNR_SEARCH: '/v3/tim-kiem-pnr',
  UPDATE_TICKET_STATUS: '/v3/cap-nhat-trang-thai-ve',
};
